import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import { FootnoteIndexContext } from '@contexts/footnote-index'
import { ContentType } from '@entries/content-types'
import ContentfulBlogArticleLink from '@entries/contentful-blog-article-link'
import ContentfulBlogTagLink from '@entries/contentful-blog-tag-link'
import ContentfulDeprecatedPageLink from '@entries/contentful-deprecated-page-link'
import ContentfulPdfLink from '@entries/contentful-pdf-link'
import ContentfulStaticPageLink from '@entries/contentful-static-page-link'
import { withDisplayName } from '@hocs/with-display-name'
import { bold } from '@render-mark/bold'
import { italic } from '@render-mark/italic'
import { underline } from '@render-mark/underline'
import { documentCaptionIndex } from '@render-node/document-caption-index'
import { hr } from '@render-node/hr'
import { hyperlinkAmplification } from '@render-node/hyperlink-amplification'
import { listItem } from '@render-node/list-item'
import { olList } from '@render-node/ol-list'
import { paragraphCaption } from '@render-node/paragraph-caption'
import { ulList } from '@render-node/ul-list'
import RichText from '@resolvers/rich-text'
import { graphql } from 'gatsby'
import React, { useContext } from 'react'

const ContentfulFootnoteRichText: Utils.EntryFC<
  Queries.ContentfulFootnoteSupFragment
> = ({ content: { content }, entryInspectorProps, fieldInspectorProps }) => {
  const index = useContext(FootnoteIndexContext)

  return (
    <RichText
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'content',
      })}
      content={content}
      options={{
        renderMark: {
          [MARKS.UNDERLINE]: underline,
          [MARKS.ITALIC]: italic,
          [MARKS.BOLD]: bold,
        },
        renderNode: {
          [BLOCKS.OL_LIST]: olList,
          [BLOCKS.UL_LIST]: ulList,
          [BLOCKS.LIST_ITEM]: listItem,
          [BLOCKS.HR]: hr,
          [INLINES.HYPERLINK]: hyperlinkAmplification,
          [INLINES.ENTRY_HYPERLINK]: {
            [ContentType.ContentfulBlogArticle]: ContentfulBlogArticleLink,
            [ContentType.ContentfulDeprecatedPage]:
              ContentfulDeprecatedPageLink,
            [ContentType.ContentfulBlogTag]: ContentfulBlogTagLink,
            [ContentType.ContentfulPdfLink]: ContentfulPdfLink,
            [ContentType.ContentfulStaticPage]: ContentfulStaticPageLink,
          },
          [BLOCKS.DOCUMENT]: documentCaptionIndex(index),
          [BLOCKS.PARAGRAPH]: paragraphCaption,
        },
      }}
    />
  )
}

export const query = graphql`
  fragment ContentfulFootnoteRichText on ContentfulFootnote {
    ...ContentfulEntry
    content {
      rich
      references {
        ...ContentfulPDFLink
        ...ContentfulBlogArticleLink
        ...ContentfulDeprecatedPageLink
        ...ContentfulBlogTagLink
        ...ContentfulStaticPageLink
      }
    }
  }
`

export default withDisplayName(
  ContentfulFootnoteRichText,
  'ContentfulFootnoteRichText'
)
